import axios from '@/api/config';

const videoMaterials = {
  addVideoMaterials(data) {
    return axios.post(`${process.env.BASE_URL}/videoMaterials/addVideoMaterials`,  data);
  },
  addBatchVideoMaterials(data) {
  return axios.post(`${process.env.BASE_URL}/videoMaterials/addBatchVideoMaterials`,  data);
  },
  changeSort(data) {
  return axios.post(`${process.env.BASE_URL}/videoMaterials/changeSort`,  data);
  },
  getVideoMaterials(data) {
  return axios.get(`${process.env.BASE_URL}/videoMaterials/getVideoMaterials`, {params: data});
  },
  addVideoMaterialsRelation(data){
    return axios.post(`${process.env.BASE_URL}/subjectVideoRelation/addVideoMaterialsRelation`,data)
  },
  updateAttachment(data){
    return axios.post(`${process.env.BASE_URL}/attachment/updateAttachment`,data)
  }
}

export default videoMaterials;



// WEBPACK FOOTER //
// ./src/api/videoMaterials.js